import { formatSplitKey } from "../commons/FormatValue";

const formatInputDate = (dateString = "", timezone = "") => {
  if (dateString !== "") {
    const d = new Date(dateString);
    const offset = (timezone === "Local" ? -1 : 1) * d?.getTimezoneOffset();
    const datetime = new Date(d?.getTime() + offset * 60000)?.toISOString();
    const [date, time] = datetime?.split("T");
    return { datetime, date, time: time?.slice(0, 5) };
  } else return { datetime: "", date: "", time: "" };
};

const calculateMonthDifference = (date1, date2) => {
  const monthsDifference =
    (date2?.getFullYear() - date1?.getFullYear()) * 12 +
    date2?.getMonth() -
    date1?.getMonth();
  return monthsDifference;
};

const monthsDifference = (date = "", month = 0) => {
  return new Date(date?.setMonth(date?.getMonth() - -month));
};

const datesDifference = (date = "", day = 0) => {
  return new Date(date?.setDate(date?.getDate() - -(day + (day < 0 && 1))));
};

const hoursDifference = (date = "", hour = 0) => {
  return new Date(date?.setTime(date?.getTime() + hour * 60 * 60 * 1000));
};

const compareDateTimes = (
  item = null,
  { name, labelName, type, value, dateOperator },
  start = null,
  end = null
) => {
  let formatValue = value;
  let itemValue = formatSplitKey(labelName || name, ".", item);

  if (type === "date") {
    const formatTimezone = (date) =>
      new Date(formatInputDate(date).date).getTime();
    itemValue = formatTimezone(itemValue);
    formatValue = formatTimezone(value);
  }

  if (![start?.name, end?.name].includes(name)) {
    if (dateOperator === ">=") return itemValue >= formatValue;
    else if (dateOperator === "<=") return itemValue <= formatValue;
    else if (dateOperator === "!=") return itemValue != formatValue;
    else return itemValue === formatValue;
  } else if (name === start?.name) return itemValue >= formatValue;
  else if (name === end?.name) return itemValue <= formatValue;
};

function toFormatISO(date) {
  if (date) {
    return new Date(date).toISOString()
  }
  return ""
}

export {
  formatInputDate,
  calculateMonthDifference,
  monthsDifference,
  datesDifference,
  hoursDifference,
  compareDateTimes,
  toFormatISO
};
